import type { ReturnPortal, ReturnPortalDto } from '~/model'

export const toReturnPortal = (returnPortal: ReturnPortalDto): ReturnPortal => {
  const { customerPortalId, address, logo, handoffMethods, businessUnitCode } = returnPortal
  return {
    customerPortalId,
    address,
    logo,
    handoffMethods,
    businessUnitCode,
  }
}
